import React from "react";
import "./SideDrawer.css";

function SideDrawer({ isOpen, onClose, title, children }) {
  if (!isOpen) return null;

  return (
    <div className="sidedrawer-backdrop">
      <div className="sidedrawer-container">
        {/* <div className="sidedrawer-header">
          <h3>{title}</h3>
          <button className="sidedrawer-close-btn" onClick={onClose}>
            ×
          </button>
        </div> */}
        <div className="sidedrawer-content">{children}</div>
      </div>
    </div>
  );
}

export default SideDrawer;
